"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("./NextAdapterPages-b4b86ccd.js");require("next/router"),require("react"),exports.NextAdapter=e.NextAdapterPages,exports.default=e.NextAdapterPages;
//# sourceMappingURL=index.cjs.production.min.js.map
